import React, { FC, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import './Login.scss'
import { useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import authService from 'Services/authService'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import { decodeToken } from 'react-jwt'
import { useLocalStorage } from 'Helpers/UseLocalStorage'
import { ExtractSubdomain } from 'Helpers/ExtractSubdomain'

type Inputs = {
  username: string
  password: string
}

type propsType = {
  onLogin?: (value: object) => void
}

interface DecodedToken {
  loanProvider: string
  username: string
  iat: string
  exp: string
}

const Login: FC<propsType> = () => {
  const [passwordType, setPasswordType] = useState('text')

  const { showAlert } = ShowTGAlert()
  const navigate = useNavigate()

  const { loginWithRedirect } = useAuth0()
  const [error, setError] = useState(null)
  const [loginRequest, setLoginRequest] = useState(false)

  const [, setUser] = useLocalStorage('__TG', null)

  const [passwordLogin, setpasswordLogin] = useState<boolean>(true)
  const [domainProvider, setLoanProvider] = useState<string | undefined>()
  const [inhouseDomain] = useState<Array<string>>([
    'admin-prod.tradegrid.co',
    'admin-dev.tradegrid.co',
    // 'localhost:2024',
  ])

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<Inputs>()

  const onSubmit = handleSubmit((data: Inputs) => processLogin(data))

  const processLogin = async (data: Inputs) => {
    if (data.username) {
      console.log(data)
      setLoginRequest(true)

      await authService.login(domainProvider, data).then(
        (response) => {
          const myDecodedToken: DecodedToken | null = decodeToken(response.data.data.token)

          if (myDecodedToken) {
            setLoginRequest(false)

            setUser({
              user: myDecodedToken,
              token: response.data.data.token,
              loanProviderAdminRole: true,
            })

            navigate(`/loan-providers/${myDecodedToken.loanProvider ?? ''}`, { replace: true })

            window.location.reload()
          }
        },
        (error) => {
          setLoginRequest(false)
          console.log('error', error)
          showAlert({
            message: error.response.data.error,
            show: true,
            title: 'Error',
            type: 'error',
          })
        },
      )
    } else {
      await loginWithRedirect({
        appState: {
          returnTo: `${window.location.origin}`,
        },
        authorizationParams: {
          connection: 'google-oauth2',
          prompt: 'login',
        },
      })
    }
  }

  useEffect(() => {
    const domain = window
    const domainHost = domain.location.host

    const domainProvider = ExtractSubdomain(domainHost)
    if (!inhouseDomain.includes(domainHost)) {
      setpasswordLogin(true)
      setLoanProvider(domainProvider?.toUpperCase())
    }
  }, [])

  return (
    <div className='login'>
      <div className='row h-100 justify-content-center'>
        <div className='col-xs-5 col-sm-8 col-md-6 col-lg-4'>
          <div className='mt-5 text-center'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='141'
              height='29'
              viewBox='0 0 141 29'
              fill='none'
            >
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M2.43347 6.88536L-7.24557e-07 6.88536L-8.02587e-07 5.10026L2.43347 5.10026L2.43347 0.555454L6.01964 0.555454L6.01964 5.10026L9.99004 5.10026L9.99004 6.88536L6.01964 6.88536L6.01964 13.5157C6.01964 14.1618 6.08795 14.7143 6.22456 15.1733C6.37826 15.6154 6.57464 15.9809 6.81372 16.2699C7.06987 16.5419 7.36018 16.7459 7.68465 16.8819C8.00911 17.0179 8.35065 17.0859 8.70927 17.0859C9.22158 17.0859 9.71681 17.0094 10.195 16.8564C10.6731 16.6864 11.0744 16.5079 11.3989 16.3209L12.1674 17.9785C11.655 18.2335 11.0659 18.446 10.3999 18.616C9.75096 18.786 9.10204 18.871 8.45311 18.871C6.52341 18.871 5.03771 18.395 3.99602 17.443C2.95432 16.4909 2.43347 15.1818 2.43347 13.5157L2.43347 6.88536ZM24.3317 6.88536L21.2578 6.88536C20.0966 6.88536 19.2086 7.19988 18.5938 7.82892C17.9791 8.44095 17.6717 9.359 17.6717 10.5831L17.6717 18.361L14.0855 18.361L14.0855 10.5831C14.0855 8.84898 14.632 7.5059 15.7249 6.55385C16.8349 5.58479 18.4231 5.10026 20.4894 5.10026L24.3317 5.10026L24.3317 6.88536ZM31.487 16.5759C29.5232 16.5759 28.5413 15.7684 28.5413 14.1533C28.5413 12.5382 29.5232 11.7306 31.487 11.7306L35.0732 11.7306L35.0732 16.5759L31.487 16.5759ZM34.0998 7.24238C34.7487 7.82042 35.0732 8.72147 35.0732 9.94554L31.487 9.94554C29.1646 9.94554 27.4483 10.2941 26.3383 10.9911C25.2454 11.6881 24.6989 12.7422 24.6989 14.1533C24.6989 15.5644 25.2454 16.6184 26.3383 17.3155C27.4483 18.0125 29.1646 18.361 31.487 18.361L38.6594 18.361L38.6594 9.94554C38.6594 9.14649 38.5057 8.42395 38.1983 7.77792C37.908 7.11488 37.4725 6.54535 36.8919 6.06932C36.3113 5.59329 35.6026 5.22777 34.7658 4.97276C33.929 4.71774 32.9642 4.59024 31.8713 4.59024C31.4614 4.59024 31.0174 4.62424 30.5393 4.69224C30.0782 4.76024 29.6086 4.86225 29.1304 4.99826C28.6523 5.11726 28.1826 5.27027 27.7216 5.45728C27.2776 5.64429 26.8677 5.86531 26.492 6.12032L27.3886 7.65041C27.9692 7.25938 28.6266 6.95337 29.3609 6.73236C30.0953 6.49434 30.8466 6.37534 31.6151 6.37534C32.6397 6.37534 33.468 6.66435 34.0998 7.24238ZM52.4797 6.88536L49.2778 6.88536C48.6972 6.88536 48.1592 6.97887 47.664 7.16588C47.1859 7.33589 46.7675 7.61641 46.4089 8.00743C46.0673 8.39845 45.7941 8.89998 45.5892 9.51201C45.4013 10.124 45.3074 10.8636 45.3074 11.7306C45.3074 12.5977 45.4013 13.3372 45.5892 13.9493C45.7941 14.5613 46.0673 15.0628 46.4089 15.4538C46.7675 15.8449 47.1859 16.1339 47.664 16.3209C48.1592 16.4909 48.6972 16.5759 49.2778 16.5759L52.4797 16.5759L52.4797 6.88536ZM49.2778 18.361C48.0995 18.361 47.0236 18.208 46.0502 17.902C45.0939 17.596 44.2742 17.1539 43.5912 16.5759C42.9081 15.9979 42.3787 15.3008 42.003 14.4848C41.6444 13.6687 41.4651 12.7507 41.4651 11.7306C41.4651 10.7106 41.6444 9.79253 42.003 8.97648C42.3787 8.16044 42.9081 7.4634 43.5912 6.88536C44.2742 6.30733 45.0939 5.86531 46.0502 5.55929C47.0236 5.25327 48.0995 5.10026 49.2778 5.10026L52.4797 5.10026L52.4797 0.510006L56.0659 0.510005L56.0659 18.361L49.2778 18.361ZM69.6567 16.6524C68.9395 16.9414 68.1625 17.0859 67.3257 17.0859C66.1474 17.0859 65.1655 16.7799 64.3799 16.1679C63.6114 15.5559 63.1248 14.5443 62.9198 13.1332L73.8576 13.1332L73.8576 11.3481C73.8576 10.2941 73.6613 9.35051 73.2685 8.51746C72.8757 7.68441 72.3463 6.97887 71.6803 6.40084C71.0143 5.8058 70.2288 5.35528 69.3237 5.04926C68.4186 4.74324 67.4538 4.59024 66.4292 4.59024C65.3362 4.59024 64.3372 4.75174 63.4321 5.07476C62.5271 5.38078 61.7415 5.83981 61.0755 6.45184C60.4266 7.04687 59.9143 7.79492 59.5386 8.69597C59.18 9.58002 59.0007 10.5916 59.0007 11.7306C59.0007 12.8867 59.1885 13.9068 59.5642 14.7908C59.957 15.6749 60.5034 16.4229 61.2036 17.0349C61.9038 17.63 62.7491 18.0805 63.7395 18.3865C64.7471 18.7095 65.8571 18.871 67.0695 18.871C67.616 18.871 68.1625 18.82 68.7089 18.718C69.2554 18.633 69.7762 18.514 70.2715 18.361C70.7838 18.191 71.2534 17.987 71.6803 17.749C72.1243 17.511 72.5086 17.2474 72.833 16.9584L71.8084 15.4283C71.1082 15.9554 70.391 16.3634 69.6567 16.6524ZM65.0459 6.52834C65.4728 6.34133 65.9339 6.24783 66.4292 6.24783C66.8732 6.24783 67.3086 6.34983 67.7355 6.55385C68.1795 6.74086 68.5638 7.04687 68.8882 7.4719C69.2298 7.87992 69.503 8.40695 69.7079 9.05299C69.9129 9.69902 70.0153 10.4641 70.0153 11.3481L62.843 11.3481C62.8601 10.4301 62.9625 9.64802 63.1504 9.00198C63.3553 8.35595 63.6114 7.82892 63.9188 7.4209C64.2433 7.01287 64.619 6.71536 65.0459 6.52834ZM83.9738 6.88536C82.7442 6.88536 81.7708 7.26789 81.0536 8.03293C80.3534 8.78097 80.0034 9.92854 80.0034 11.4756C80.0034 13.0227 80.3534 14.1788 81.0536 14.9438C81.7708 15.6919 82.7442 16.0659 83.9738 16.0659L87.1757 16.0659L87.1757 6.88536L83.9738 6.88536ZM90.7619 18.106C90.7619 18.905 90.6082 19.6276 90.3008 20.2736C89.9934 20.9367 89.5323 21.5062 88.9176 21.9822C88.3199 22.4582 87.5599 22.8238 86.6378 23.0788C85.7327 23.3338 84.6739 23.4613 83.4614 23.4613C83.0516 23.4613 82.6076 23.4273 82.1294 23.3593C81.6684 23.3083 81.1988 23.2148 80.7206 23.0788C80.2424 22.9598 79.7728 22.7983 79.3117 22.5942C78.8677 22.4072 78.4579 22.1862 78.0822 21.9312L78.9787 20.4011C79.5594 20.7921 80.2168 21.0982 80.9511 21.3192C81.6854 21.5572 82.4368 21.6762 83.2053 21.6762C84.4861 21.6762 85.468 21.3872 86.1511 20.8091C86.8342 20.2311 87.1757 19.3301 87.1757 18.106L87.1757 17.851L83.9738 17.851C82.7954 17.851 81.7196 17.698 80.7462 17.392C79.7899 17.0859 78.9702 16.6524 78.2871 16.0914C77.604 15.5304 77.0746 14.8588 76.699 14.0768C76.3403 13.2947 76.161 12.4277 76.161 11.4756C76.161 10.5236 76.3403 9.65652 76.699 8.87448C77.0747 8.09243 77.604 7.4209 78.2871 6.85986C78.9702 6.29883 79.7899 5.86531 80.7462 5.55929C81.7196 5.25327 82.7954 5.10026 83.9738 5.10026L90.7619 5.10026L90.7619 18.106ZM101.381 6.88536L104.455 6.88536L104.455 5.10026L100.613 5.10026C98.5465 5.10026 96.9584 5.58479 95.8484 6.55385C94.7554 7.5059 94.209 8.84897 94.209 10.5831L94.209 18.361L97.7951 18.361L97.7951 10.5831C97.7951 9.359 98.1025 8.44095 98.7173 7.82892C99.3321 7.19988 100.22 6.88536 101.381 6.88536ZM110.209 18.361L106.622 18.361L106.622 5.35528L110.209 5.35528L110.209 18.361ZM110.337 1.91259C110.337 2.42261 110.157 2.87314 109.799 3.26416C109.457 3.63818 108.996 3.82519 108.416 3.82519C107.835 3.82519 107.365 3.63818 107.007 3.26416C106.665 2.87314 106.494 2.42261 106.494 1.91258C106.494 1.40256 106.665 0.960532 107.007 0.586511C107.365 0.195489 107.835 -2.37871e-05 108.416 -2.38125e-05C108.979 -2.38371e-05 109.44 0.195489 109.799 0.586511C110.157 0.960532 110.337 1.40256 110.337 1.91259ZM121.096 6.88536L124.298 6.88536L124.298 16.5759L121.096 16.5759C120.516 16.5759 119.978 16.4909 119.482 16.3209C119.004 16.1339 118.586 15.8449 118.227 15.4538C117.886 15.0628 117.612 14.5613 117.408 13.9493C117.22 13.3372 117.126 12.5977 117.126 11.7306C117.126 10.8636 117.22 10.124 117.408 9.51201C117.613 8.89998 117.886 8.39845 118.227 8.00743C118.586 7.61641 119.004 7.33589 119.482 7.16588C119.978 6.97887 120.516 6.88536 121.096 6.88536ZM117.869 17.902C118.842 18.208 119.918 18.361 121.096 18.361L127.884 18.361L127.884 0.510006L124.298 0.510006L124.298 5.10026L121.096 5.10026C119.918 5.10026 118.842 5.25327 117.869 5.55929C116.912 5.86531 116.093 6.30733 115.41 6.88537C114.726 7.4634 114.197 8.16044 113.821 8.97648C113.463 9.79253 113.283 10.7106 113.283 11.7306C113.283 12.7507 113.463 13.6687 113.821 14.4848C114.197 15.3008 114.726 15.9979 115.41 16.5759C116.093 17.1539 116.912 17.596 117.869 17.902ZM133.529 1.04022L133.529 5.34266L134.167 5.34266L134.167 1.04022L135.762 1.04022L135.762 0.464569L131.941 0.464569L131.941 1.04022L133.529 1.04022ZM136.4 0.464569L136.4 5.34266L137.015 5.34266L137.015 1.18996L138.409 5.34266L138.984 5.34266L140.385 1.25984L140.385 5.34266L141 5.34266L141 0.464569L140.142 0.464569L138.988 3.85861C138.871 4.20245 138.786 4.4631 138.731 4.64057C138.683 4.48085 138.606 4.24016 138.501 3.9185L137.36 0.464569L136.4 0.464569Z'
                fill='white'
              />
              <rect
                width='38.9373'
                height='4.12971'
                transform='matrix(1 0 0 -1 0 28.318)'
                fill='#E873A8'
              />
            </svg>
          </div>
          <div className='card'>
            <div className='card-body'>
              <h2 className='h-20 justify-center w-full text-center'>Login</h2>
              <form className='space-y-6' action='#' onSubmit={onSubmit}>
                {passwordLogin === false && (
                  <React.Fragment>
                    <div className='form-goup mt-4'>
                      <label
                        htmlFor='username'
                        className='block text-sm font-medium leading-6 text-gray-900'
                      >
                        Username
                      </label>
                      <div className='mt-2'>
                        <input
                          id='username'
                          type='text'
                          autoComplete='username'
                          required
                          className='form-control'
                          {...register('username', { required: 'field cannot be empty' })}
                        />
                      </div>
                      <div className='err text-danger'>
                        {errors.username && errors.username.message}
                      </div>
                    </div>
                    <div className='form-goup mt-4'>
                      <div className='flex items-center justify-between'>
                        <label
                          htmlFor='password'
                          className='block text-sm font-medium leading-6 text-gray-900'
                        >
                          Password
                        </label>
                      </div>
                      <div className='mt-2 password-container'>
                        <input
                          id='password'
                          type={passwordType}
                          autoComplete='current-password'
                          required
                          className='form-control'
                          {...register('password', { required: 'field cannot be empty' })}
                        />
                        <span
                          className={
                            passwordType === 'password' ? 'd-icon d-eye-open' : 'd-icon d-eye-close'
                          }
                          onClick={() =>
                            setPasswordType(passwordType === 'password' ? 'text' : 'password')
                          }
                        ></span>
                        <div className='err text-danger'>
                          {errors.password && errors.password.message}
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}

                {error !== null && (
                  <div className='alert alert-danger d-flex align-items-center mt-2 alert-dismissible fade show'>
                    <i className='d-icon d-warning text-danger bi bi-exclamation-triangle-fill flex-shrink-0 me-2'></i>
                    <div className='text-danger'>{error}</div>
                    <button
                      type='button'
                      className='btn-close'
                      data-bs-dismiss='alert'
                      aria-label='Close'
                      onClick={() => setError(null)}
                    ></button>
                  </div>
                )}

                <div className='w-100 text-center'>
                  <button
                    type='submit'
                    className='btn bg-tg w-50 mt-4 mb-2'
                    disabled={loginRequest}
                  >
                    {loginRequest && <span className='spinner-border spinner-border-sm'></span>}{' '}
                    Login
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className='copyright'>© 2023 Tradegrid - All rights reserved.</div>
      </div>
    </div>
  )
}

export default Login
